// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"487":"cf59d909","990":"fac6f846"}[chunkId] + ".chunk.css";
};